import styled from '@emotion/styled';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { InfoIcon } from 'src/domains/layouts/shared/assets/icons/InfoIcon';

import { withConfig } from 'src/withConfig';



interface AssigneeInfoWrapperPropsType {

    variant: DefaultComponentVariantType | null;

}



export const AssigneeInfoWrapper = withConfig(theme => styled('li', { label: 'AssigneeInfoWrapper' })<AssigneeInfoWrapperPropsType>`

    align-self: flex-start;

    background-color: ${theme.star.traderChat.messages.bgColorQuaternary};

    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ?`${theme.star.radius.medium} ${theme.star.radius.medium} ${theme.star.radius.medium} 0` : `0 ${theme.star.radius.medium} ${theme.star.radius.medium} ${theme.star.radius.medium}`};

    color: ${theme.star.traderChat.messages.txtColorQuaternary};

    font-size: ${theme.star.fontSize.small};

    line-height: 1.4;

    margin: 0 0 38px;

    min-width: 52px;

    padding: 12px 8px 12px 24px;

    position: relative;

    &:last-of-type {

        margin-bottom: 0;

    }

`);



export const InfoIconWrapper = styled(InfoIcon, { label: 'InfoIconWrapper' })`

    fill: currentcolor;

    left: 8px;

    position: absolute;

    top: 13px;

    width: 12px;

`;

